<template>
  <v-dialog
    v-model='dialog'
    persistent
    max-width="80%"
    scrollable
  >
    <v-card v-if="dialog">
        <v-card-title flat class='blue white--text title py-2'>{{ 'TITLE_DIALOG_SEARCH_MASK_CONFIG' | translate}}
        <v-spacer></v-spacer>
          <v-btn small @click="close" icon flat dark>
            <v-icon>clear</v-icon>
          </v-btn>
        </v-card-title>
      <v-card flat color="transparent" class="pt-3" style="overflow-y: auto; height:80vh;">
        <TableSearchMaskColumns ref="refMask" @onFilterFieldsSaved="onSaved"></TableSearchMaskColumns>
      </v-card>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-flex xs12 sm3 class="ma-3" justify-center>
          <v-btn dark color="blue" class="text-none" block @click="addItems()">{{ 'BUTT_SAVE' | translate}}</v-btn>
        </v-flex>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import TableSearchMaskColumns from '@/components/tables/TableSearchMaskColumns.vue'
  import Vue from "vue";

  export default {
    name: 'DialogConfigMask',
    components: {TableSearchMaskColumns},
    methods: {
      reset: function () {
        this.dialog = false
      },
      close: function () {
        this.dialog = false
      },
      onSaved: function (data) {
        Vue.prototype.$api.debug('onSaved', data)
        this.dialog = false
        this.$emit('searchFieldConfigHasChanged', data)
      },
      addItems: function () {
        this.$refs['refMask'].addItems()
      },
      show(item) {
        this.item = item
        this.dialog = true
        var cmp = this

        this.$nextTick(() => {
          cmp.$refs['refMask'].initialLoad('Peergroup', true)
        })
      }
    },
    data() {
      return {
        dialog: false,
        warning: false,
        item: {name: ''},
        currentCurrency: 1,
        warnMessage: ''
      }
    },
    mounted() {
      //
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/dialogs/DialogConfigMask.vue